import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/how-do-i-know-if-my-microsoft-has-a-virus")({
  beforeLoad: () => {
    throw redirect({ href: "/articles/how-do-i-know-if-my-microsoft-has-a-virus", statusCode: 301 });
  },
});
